// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3xH2X","header":"PatientQuestionnaire_header__2fazJ","info":"PatientQuestionnaire_info__2d9g6"};